// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"233c92b8","396":"63fa2d88","455":"e4707120","857":"2d9178dc","977":"58790150"}[chunkId] + ".chunk.js";
};